import * as React from 'react'

import { Button } from '@thg-commerce/gravity-elements'

import {
  iconWrapperStyle,
  infoBoxesFlexStyle,
  Paragraph,
  Title,
  InfoBoxesItemWrapper,
} from '../style'

export interface InfoBoxItemProps {
  title: string
  image: React.ReactElement
  buttonText: string
  description: string
  buttonOnClick: () => void
}

export const InfoBoxItem = (props: InfoBoxItemProps) => {
  return (
    <InfoBoxesItemWrapper>
      <div style={infoBoxesFlexStyle}>
        <div style={iconWrapperStyle}>{props.image}</div>
        <Title>
          {props.title}
          <Button emphasis="low" onClick={props.buttonOnClick}>
            {props.buttonText}
          </Button>
        </Title>
      </div>
      <Paragraph>{props.description}</Paragraph>
    </InfoBoxesItemWrapper>
  )
}
